import React from "react";
import { Button, ButtonGroup, Form } from "react-bootstrap";
import { ENTRY_PROTECTION_MODES, normalizeEntryProtectionMode } from "../../../../trades/tradeUtils";
import "./EntryProtectionSelector.css";

export default function EntryProtectionSelector({ value, onChange }) {
  const selected = normalizeEntryProtectionMode(value);
  return (
    <Form.Group className="entryProtection mb-3">
      <Form.Label>Entry confirmation</Form.Label>
      <ButtonGroup className="entryProtectionOptions" aria-label="Entry confirmation mode">
        {ENTRY_PROTECTION_MODES.map((mode) => (
          <Button
            key={mode}
            type="button"
            size="sm"
            variant={selected === mode ? "primary" : "outline-primary"}
            onClick={() => onChange(mode)}
          >
            {mode === "ADAPT15M" ? "Adapt" : mode}
          </Button>
        ))}
      </ButtonGroup>
    </Form.Group>
  );
}
